import axios from 'axios'

export const Api = {
  addProduct: async (id, quantity) => {
    return await axios.post('/cart/add.js', { id, quantity })
  },
  removeProduct: async (id) => {
    return await axios.post('/cart/update.js', { updates: { [id]: 0 } })
  },
  updateProduct: async (id, quantity) => {
    return await axios.post('/cart/update.js', { updates: { [id]: quantity } })
  },
  fetchCart: async () => {
    return await axios.get('/cart.js')
  },
  fetchProduct: async (handle) => {
    return await axios.get(`/products/${handle}.js`)
  },
  fetchProductHtml: async (handle) => {
    const origin = window.location.origin
    const url = origin + '/products/' + handle
    return await axios.get(url)
  },
}
